import pickBy from 'hs-lodash/pickBy';

const trimEmptyValuesFromObject = function trimEmptyValuesFromObject(obj) {
  return pickBy(obj, value => {
    return value !== '' && value !== undefined && value !== null;
  });
};

export default trimEmptyValuesFromObject;